import { IoArrowBack } from 'react-icons/io5'


const BackButton = ({ onClick }) => {
    return (
        <div className='back-btn-container' onClick={onClick}><IoArrowBack /></div>
    )
}

export default BackButton